export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 inline-flex items-center gap-3">
            <span className="text-primary-400 font-heading text-5xl font-light">&ldquo;</span>
            What Our Users Say
            <span className="text-primary-400 font-heading text-5xl font-light">&rdquo;</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-4 max-w-lg mx-auto">
            Real feedback from the Sugargoo spreadsheet community
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1 - Marcus */}
          <div className="bg-background-50 rounded-xl p-6 md:p-7">
            <div className="flex items-center gap-1.5 mb-4">
              <div className="flex items-center gap-0.5 bg-accent-100 text-accent-600 px-2.5 py-1 rounded-full text-xs font-semibold">
                <i className="ri-star-fill text-xs"></i>
                4.9
              </div>
              <div className="flex gap-0.5 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
              </div>
            </div>
            <blockquote className="text-sm text-foreground-600 leading-relaxed mb-6 italic font-heading">
              &ldquo;This Sugargoo spreadsheet is genuinely the most organized resource I have ever used. Found my entire summer wardrobe through these links, and the QC tips saved me from a couple of bad purchases.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-200 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20man%20with%20short%20hair%20wearing%20white%20shirt%20outdoor%20portrait%20in%20warm%20afternoon%20light%2C%20soft%20bokeh%20green%20background%2C%20friendly%20expression%2C%20natural%20editorial%20portrait%20photography&width=100&height=100&seq=testi-marcus-v2&orientation=squarish"
                  alt="Customer review portrait - Marcus J satisfied with Sugargoo Spreadsheet verified finds"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">Marcus J.</p>
                <p className="text-xs text-foreground-400">@marcusfinds</p>
              </div>
            </div>
          </div>

          {/* Card 2 - Sophie */}
          <div className="bg-background-50 rounded-xl p-6 md:p-7">
            <div className="flex items-center gap-1.5 mb-4">
              <div className="flex items-center gap-0.5 bg-accent-100 text-accent-600 px-2.5 py-1 rounded-full text-xs font-semibold">
                <i className="ri-star-fill text-xs"></i>
                4.8
              </div>
              <div className="flex gap-0.5 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
              </div>
            </div>
            <blockquote className="text-sm text-foreground-600 leading-relaxed mb-6 italic font-heading">
              &ldquo;I was spending hours searching through individual listings before finding this site. Now I just check the spreadsheet once a week and grab whatever catches my eye. The category breakdown is a game changer.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-200 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20woman%20with%20wavy%20hair%20portrait%20in%20natural%20window%20light%2C%20warm%20golden%20hour%20tones%2C%20casual%20style%20wearing%20cream%20sweater%2C%20editorial%20portrait%20photography%2C%20soft%20genuine%20smile&width=100&height=100&seq=testi-sophie-v2&orientation=squarish"
                  alt="Customer review portrait - Sophie L happy with Sugargoo Spreadsheet shopping experience"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">Sophie L.</p>
                <p className="text-xs text-foreground-400">@sophieshops</p>
              </div>
            </div>
          </div>

          {/* Card 3 - Alex */}
          <div className="bg-background-50 rounded-xl p-6 md:p-7">
            <div className="flex items-center gap-1.5 mb-4">
              <div className="flex items-center gap-0.5 bg-accent-100 text-accent-600 px-2.5 py-1 rounded-full text-xs font-semibold">
                <i className="ri-star-fill text-xs"></i>
                4.7
              </div>
              <div className="flex gap-0.5 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
              </div>
            </div>
            <blockquote className="text-sm text-foreground-600 leading-relaxed mb-6 italic font-heading">
              &ldquo;Been using Sugargoo for two years and this spreadsheet platform makes it ten times easier. The verified seller tags and price comparisons are exactly what the community needed.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-200 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20man%20with%20glasses%20casual%20portrait%20in%20urban%20setting%20with%20warm%20sunlight%2C%20brick%20wall%20background%20softly%20blurred%2C%20editorial%20portrait%20photography%2C%20friendly%20confident%20expression&width=100&height=100&seq=testi-alex-v2&orientation=squarish"
                  alt="Customer review portrait - Alex K long-time Sugargoo Spreadsheet user"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">Alex K.</p>
                <p className="text-xs text-foreground-400">@alexreps</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}